import {Button, ButtonProps, Stack, Typography} from '@mui/material'
import {isFunction} from 'lodash'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {getTranslationKey} from '../utils'

type NoDataPlaceholderProps = {
  noDataMessage?: string
  translationPrefix?: string
  onActionClick?: ButtonProps['onClick']
  actionLabel?: string
}

export const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = ({
  noDataMessage,
  translationPrefix,
  onActionClick,
  actionLabel
}) => {
  const {t} = useTranslation()

  return (
    <Stack spacing={2} alignItems="center">
      <Typography>
        {noDataMessage ??
          t(getTranslationKey('dataContentWrapper.message.noData', translationPrefix))}
      </Typography>
      {isFunction(onActionClick) && (
        <Button
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onActionClick(event)
          }}
          variant="outlined"
          color="primary"
        >
          {actionLabel ??
            t(getTranslationKey('dataContentWrapper.action.close', translationPrefix))}
        </Button>
      )}
    </Stack>
  )
}
